import { useContext } from "react";
import { NavPage } from "../../services/NavService";
import { EditorNav } from "../EditorNav/EditorNav";
import { TopNav } from "../TopNav/TopNav";
import "../../style/editor.scss";
import "./DoorTypeEditor.scss"
import { EditorContext } from "../EditorCommon/EditorContext";
import { Card } from "react-bootstrap";

export default function DoorTypeEditor() {

    const ec = useContext(EditorContext);

    async function setDoorProduct(id: number|null) {
        const result = await ec.cabinetService.setDoorProduct(id);
        if (result.success) {
            ec.navService.navigateNextAvailable(NavPage.DoorTypes);
        }
    }

    const doorTypes = ec.cabinetService.getProductLine()?.doors.map(dp => {
        const border = (dp.id === ec.cabinet.doorProductId) ? "primary" : undefined;
        return (
            <Card className="door-type"
                onClick={() => setDoorProduct(dp.id)}
                border={border}
                key={dp.id}>
                {dp.imageUrl && <Card.Img variant="top" src={dp.imageUrl} />}
                <Card.Body>
                    <Card.Title>{dp.name}</Card.Title>
                    {dp.description && (
                        <Card.Text style={{ whiteSpace: "pre-line" }}>
                            {dp.description}
                        </Card.Text>
                    )}
                </Card.Body>
            </Card>
        )
    });

    const noDoor = (
        <Card className="door-type"
            onClick={() => setDoorProduct(null)}
            key={-1}>
            <Card.Img variant="top" src="/imgs/nodoors.jpg" alt="" />
            <Card.Body>
                <Card.Title>{ec.translator("doorTypeEditor noDoor title", "Ingen døre")}</Card.Title>
                <Card.Text style={{ whiteSpace: "pre-line" }}>
                    {ec.translator("doorTypeEditor noDoor description", "En løsning uden døre, kun med indretning og gavle.")}
                </Card.Text>
            </Card.Body>
        </Card>
    );


    return (
        <div className="editor door-type-editor">
            <TopNav header={ec.translator("doorTypeEditor header", "Dørtype")} />


            <div className="box-container main-editor">

                <div className="container container-lg door-type-container">
                    {doorTypes?.concat(noDoor)}
                </div>
            </div>
            <EditorNav currentPage={NavPage.DoorTypes} />
        </div>
    );
}
